import isObject_default from "./isObject.js";
import isFunction_default from "./isFunction.js";
import _isMasked_default from "./_isMasked.js";
import _toSource_default from "./_toSource.js";

//#region ../../node_modules/lodash-es/_baseIsNative.js
/**
* Used to match `RegExp`
* [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
*/
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */
var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
* The base implementation of `_.isNative` without bad shim checks.
*
* @private
* @param {*} value The value to check.
* @returns {boolean} Returns `true` if `value` is a native function,
*  else `false`.
*/
function baseIsNative(value) {
	if (!isObject_default(value) || _isMasked_default(value)) return false;
	var pattern = isFunction_default(value) ? reIsNative : reIsHostCtor;
	return pattern.test(_toSource_default(value));
}
var _baseIsNative_default = baseIsNative;

//#endregion
export { _baseIsNative_default as default };
//# sourceMappingURL=_baseIsNative.js.map